import logo from "./logo.svg";
import { useContext } from "react";
import { Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "./App.css";
import Dashboard from "./components/Dashboard/Dashboard";
import StockDetail from "./components/StockDetail/StockDetail";
import Navbar from "./components/Navbar/Navbar";
import Stock from "./components/Stock/Stock";
import News from "./components/News/News";
import AllStocks from "./components/AllStocks/AllStocks";
import Commodities from "./components/Commodities/Commodities";
import CommoditiesDash from "./components/CommoditiesDash/CommoditiesDash";
import Nasdaq from "./components/Nasdaq/Nasdaq";
import Nifty from "./components/Nifty/Nifty";
import NiftyDetail from "./components/NiftyDetail/NiftyDetail";
import SearchStock from "./components/SearchStock/SearchStock";
import HeatMap from "./components/HeatMap/HeatMap";
import PrivateRoute from "./components/PrivateRoute/PrivateRoute";
import { AuthContext } from "./context/AuthContext";
import { StockProvider } from "./context/StockContext";
import HeatMapDetail from "./components/HeatMapDetail/HeatMapDetail";

import Login from "./components/Login/Login";
import StockHeatMap from "./components/StockHeatMap/StockHeatMap";
import SearchGlobal from "./components/SearchGlobal/SearchGlobal";
import GlobalStock from "./components/GlobalStock/GlobalStock";
import AllGlobal from "./components/AllGlobal/AllGlobal";
import UserProfile from "./components/UserProfile/UserProfile";
import WatchList from "./components/WatchList/WatchList";
import AllCommodities from "./components/AllCommodities/AllCommodities";
import PcrPage from "./components/PcrPage/PcrPage";
import OptionChain from "./components/OptionChain/OptionChain";
import ActiveContracts from "./components/ActiveContracts/ActiveContracts";
import GlobalDaily from "./components/GlobalDaily/GlobalDaily";
import MarketCap from "./components/MarketCap/MarketCap";
import OptionPage from "./components/OptionPage/OptionPage";
import OptionChainPage from "./components/OptionChainPage/OptionChainPage";
import Testpage from "./components/TestPage/Testpage";
import StockTest from "./components/StockTest/StockTest";
import StockTestDetail from "./components/StockTestDetail/StockTestDetail";
import MaxPain from "./components/Maxpain/MaxPain";
import PcrTestPage from "./components/PcrTestPage/PcrTestPage";
import DbTest from "./components/DbTest/DbTest";
import MaxPainPage from "./components/MaxPainPage/MaxPainPage";
import LandingPage from "./components/LandingPage/LandingPage";
import GlobalTest from "./components/GlobalTest/GlobalTest";
import GlobalTestDetail from "./components/GlobalTestDetail/GlobalTestDetail";
import Chat from "./components/Chat/Chat";
import ChatPanel from "./components/ChatPanel/ChatPanel";
import MarketTrend from "./components/MarketTrend/MarketTrend";
import ChatPanel2 from "./components/ChatPanel2/ChatPanel2";
import AIFloatButton from "./components/AIFloatButton/AIFloatButton";
import TrendAnalysis from "./components/TrendAnalysis/TrendAnalysis";
import Register from "./components/Register/Register";
import LoginForm from "./components/LoginForm/LoginForm";
import ForgotPassword from "./components/ForgotPassword/ForgotPassword";
import ResetPassword from "./components/ResetPassword/ResetPassword";
import DailyTrend from "./components/DailyTrend/DailyTrend";
import CaptchaTest from "./components/Captcha/Captcha";
import { useAuth } from "./context/AuthNewContext";
import AdminDashboard from "./components/Admin/Admin";
import AdminDetail from "./components/AdminDetail/AdminDetail";
import FeedbackPage from "./components/Feedback/Feedback";
import Footer from "./components/Footer/Footer";
import SingleStock from "./components/SingleStock/SingleStock";
import StockCard from "./components/StockCard/StockCard";
import TestSearch from "./components/TestSearch/TestSearch";
import StockDetailPage from "./components/StockDetailPage/StockDetailPage";
import Dropdown from "./components/Dropdown/Dropdown";
import Helper from "./components/Helper/Helper";
import IndexDetail from "./components/IndexDetail/IndexDetail";
import SingleIndex from "./components/SingleIndex/SingleIndex";
import IndexTabs from "./components/IndexTabs/IndexTabs";
import DayHighStrategy from "./components/DayHighStrategy/DayHighStrategy";
import CrossoverDashboard from "./components/CrossoverDashboard/CrossoverDashboard";
import CrossoverDashboardPage from "./components/CrossoverDashboardPage/CrossoverDashboardPage";
import OpenHighScreener from "./components/Screeners/OpenHighScreener";
import OpenLowScreener from "./components/Screeners/OpenLowScreener";
import TradeDealPage from "./components/TradeDealPage/TradeDealPage";
import FiiDiiPage from "./components/FiiDii/FiiDii";
import FiiDii from "./components/FiiDii/FiiDii";
import FuturesPage from "./components/FuturesPage/FuturesPage";
import StrategyDashboard from "./components/StrategyDashboard/StrategyDashboard";
import SmartMoneyScreener from "./components/Screeners/SmartMoneyScreener";
import CrossoverMomentum from "./components/Screeners/CrossoverMomentum";
import ScreenerPage from "./components/ScreenerPage/ScreenerPage";
import HighVolumeScreener from "./components/Screeners/HighVolumeScreener";
import WeekHighBreakout from "./components/Screeners/WeekHighBreakout";
import MarketScreener from "./components/Screeners/MarketScreener";
import Logs from "./components/Logs/Logs";
import GlobalScreenerPage from "./components/ScreenerPage/GlobalScreenerPage";
import TradeDealPage1 from "./components/TradeDealPage1/TradeDealPage1";
import EmaStratDashboard from "./components/EmaStratDashboard/EmaStratDashboard";
// import { useAuth } from "./context/AuthNewContext";

function App() {
  const { user } = useAuth();
  const finalUser = user?.token;
  console.log("User", user);

  // useEffect(() => {
  //   const handleStorageChange = () => {
  //     setToken(localStorage.getItem("authToken"));
  //   };

  //   // Listen for storage changes (login/logout)
  //   window.addEventListener("storage", handleStorageChange);

  //   // ✅ Also listen to manual "storage" dispatch (for same-tab updates)
  //   return () => {
  //     window.removeEventListener("storage", handleStorageChange);
  //   };
  // }, []);
  // const token = localStorage.getItem("authToken");
  // console.log("Token", token);
  return (
    <div className="App">
      {/* {token && <Navbar />} */}
      {finalUser && <Navbar />}
      {/* {finalUser && <IndexTabs />} */}

      <div className="pages">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* <Route path="/" element={<Home />} /> */}
          {/* <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          /> */}
          <Route
            path="/stock/:id"
            element={
              <PrivateRoute>
                <StockDetail />
              </PrivateRoute>
            }
          />
          <Route
            // path="/stockdetail/:companyCode"
            path="/stockdetail/:symbol/:securityId"
            element={
              <PrivateRoute>
                <Stock />
              </PrivateRoute>
            }
          />
          <Route
            path="/news"
            element={
              <PrivateRoute>
                <News />
              </PrivateRoute>
            }
          />
          <Route
            path="/allstocks/:type"
            element={
              <PrivateRoute>
                <AllStocks />
              </PrivateRoute>
            }
          />
          <Route
            path="/commodities"
            element={
              <PrivateRoute>
                <Commodities />
              </PrivateRoute>
            }
          />
          <Route
            path="/commoditiesdash"
            element={
              <PrivateRoute>
                <CommoditiesDash />
              </PrivateRoute>
            }
          />

          {/* Main Page */}

          {/* 1. Dashboard Testpage */}
          <Route
            // path="/testpage"
            path="/dashboard"
            element={
              <PrivateRoute>
                <Testpage />
              </PrivateRoute>
            }
          />
          {/* 2. ALl stocks detail */}
          <Route
            path="/stocktestdetail/:selectedIndex/:type"
            element={
              <PrivateRoute>
                <StockTestDetail />
              </PrivateRoute>
            }
          />
          {/* 3. Stock Test Stock Detail Page */}
          <Route
            // path="/stocktest/:companyCode"
            path="/stockInfo/:companyCode"
            element={
              <PrivateRoute>
                <StockTest />
              </PrivateRoute>
            }
          />

          {/* 4. global detail page */}
          <Route
            path="/globalInfo/:companyCode"
            element={
              <PrivateRoute>
                <GlobalTest />
              </PrivateRoute>
            }
          />
          {/* 5. Navbar components
             1) Live Trend
          */}
          <Route
            path="/dailytrend"
            element={
              <PrivateRoute>
                <DailyTrend />
              </PrivateRoute>
            }
          />

          <Route
            path="/marketScreener"
            element={
              <PrivateRoute>
                <MarketScreener />
              </PrivateRoute>
            }
          />
          {/* 5. Navbar components
             2) EOD Trend
          */}
          <Route
            path="/trendanalysis"
            element={
              <PrivateRoute>
                <TrendAnalysis />
              </PrivateRoute>
            }
          />
          <Route
            path="/adminpage"
            element={
              <PrivateRoute>
                <AdminDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/user/:userID"
            element={
              <PrivateRoute>
                <AdminDetail />
              </PrivateRoute>
            }
          />
          {/* 5. Navbar components
             3) Heat Map
          */}
          <Route
            path="/heatmap"
            element={
              <PrivateRoute>
                <HeatMapDetail />
              </PrivateRoute>
            }
          />
          {/* 5. Navbar components
             4) Option Chain
          */}
          <Route
            path="/optionchainpage"
            element={
              <PrivateRoute>
                <OptionChainPage />
              </PrivateRoute>
            }
          />
          {/* 5. Navbar components
             5) Max Pain
          */}
          <Route
            path="/maxpain"
            element={
              <PrivateRoute>
                <MaxPain />
              </PrivateRoute>
            }
          />
          {/* 5. Navbar components
             6) Most Active Contracts
          */}
          <Route
            path="/activecontracts"
            element={
              <PrivateRoute>
                <ActiveContracts />
              </PrivateRoute>
            }
          />
          {/* Option chain for stock detail */}
          <Route
            path="/optionpage/:type/:symbol/:securityId"
            element={
              <PrivateRoute>
                <OptionPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/fiidii"
            element={
              <PrivateRoute>
                <FiiDii />
              </PrivateRoute>
            }
          />

          {/* Max Pain for stock detail */}
          <Route
            path="/maxpain/:type/:symbol/:securityId"
            element={
              <PrivateRoute>
                <MaxPainPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/futures"
            element={
              <PrivateRoute>
                <FuturesPage />
              </PrivateRoute>
            }
          />

          {/* Global stock Typewise EG:Gainers,losers and Most active*/}

          <Route
            path="/globaltestdetail/:type"
            element={
              <PrivateRoute>
                <GlobalTestDetail />
              </PrivateRoute>
            }
          />

          {/* <Route path="/nasdaq" element={<Nasdaq />} /> */}
          <Route
            path="/nifty"
            element={
              <PrivateRoute>
                <Nifty />
              </PrivateRoute>
            }
          />
          <Route
            path="/commoditiesdetail"
            element={
              <PrivateRoute>
                <AllCommodities />
              </PrivateRoute>
            }
          />
          <Route
            // path="/stocktest/:companyCode"
            path="/feedback"
            element={
              <PrivateRoute>
                <FeedbackPage />
              </PrivateRoute>
            }
          />

          <Route path="/register" element={<Register />} />
          <Route path="/loginpage" element={<LoginForm />} />
          {/* <Route path="/niftydetail/:stock/:id" element={<NiftyDetail />} /> */}
          <Route
            path="/search/:searchtext"
            element={
              <PrivateRoute>
                <SearchStock />
              </PrivateRoute>
            }
          />
          <Route
            path="/stockmap"
            element={
              <PrivateRoute>
                <StockHeatMap />
              </PrivateRoute>
            }
          />
          <Route
            path="/allglobal/:type"
            element={
              <PrivateRoute>
                <AllGlobal />
              </PrivateRoute>
            }
          />
          <Route
            path="/searchglobal/:searchText"
            element={
              <PrivateRoute>
                <SearchGlobal />
              </PrivateRoute>
            }
          />
          <Route
            path="/globalstock/:ticker"
            element={
              <PrivateRoute>
                <GlobalStock />
              </PrivateRoute>
            }
          />
          <Route
            path="/userprofile"
            element={
              <PrivateRoute>
                <UserProfile />
              </PrivateRoute>
            }
          />
          <Route path="/pcr/:symbol" element={<PcrPage />} />

          <Route path="/optionchain" element={<OptionChain />} />

          <Route
            path="/watchlist"
            element={
              <PrivateRoute>
                <WatchList />
              </PrivateRoute>
            }
          />
          <Route
            path="/oneStock"
            element={
              <PrivateRoute>
                <SingleStock />
              </PrivateRoute>
            }
          />

          <Route
            path="/oneIndex"
            element={
              <PrivateRoute>
                <SingleIndex />
              </PrivateRoute>
            }
          />
          <Route
            path="/globaltestdetail/:type"
            element={
              <PrivateRoute>
                <GlobalTestDetail />
              </PrivateRoute>
            }
          />
          <Route
            path="/helper"
            element={
              <PrivateRoute>
                <Helper />
              </PrivateRoute>
            }
          />
          <Route path="/globaldaily" element={<GlobalDaily />} />
          {/* <Route path="/heatmap" element={<HeatMap />} /> */}
          <Route path="/marketcap" element={<MarketCap />} />
          <Route
            // path="/testpage"
            path="/strategy"
            element={
              <PrivateRoute>
                <StrategyDashboard />
              </PrivateRoute>
            }
          />
          <Route path="/smartmoney" element={<SmartMoneyScreener />} />
          <Route path="/crossovermomentum" element={<CrossoverMomentum />} />
          <Route path="/screenerpage" element={<ScreenerPage />} />
          <Route path="/screener/:tabKey" element={<ScreenerPage />} />
          <Route path="/smartmoney" element={<ScreenerPage />} />
          <Route path="/crossovermomentum" element={<ScreenerPage />} />
          <Route path="/highvolume" element={<HighVolumeScreener />} />
          <Route path="/weekPrice" element={<WeekHighBreakout />} />
          <Route path="/chat" element={<ChatPanel />} />
          <Route path="/stockcard/:companyCode" element={<StockCard />} />
          <Route
            path="/dayhigh/:symbol/:securityId"
            element={<DayHighStrategy />}
          />
          <Route
            path="/signals/:symbol/:securityId"
            element={<CrossoverDashboardPage />}
          />

          {/* <Route path="/stocktest/:companyCode" element={<StockTest />} /> */}

          <Route path="/pcrtestpage" element={<PcrTestPage />} />
          <Route path="/tradedeal" element={<TradeDealPage />} />
          <Route path="/tradedeal1" element={<TradeDealPage1 />} />
          <Route path="/screener/openhigh" element={<OpenHighScreener />} />
          <Route path="/screener/openlow" element={<OpenLowScreener />} />
          <Route path="/dbtest" element={<DbTest />} />
          <Route path="/markettrend" element={<MarketTrend />} />
          <Route path="/maxpainpage/:type/:symbol" element={<MaxPainPage />} />
          <Route path="/captchapage" element={<CaptchaTest />} />
          <Route path="/testsearch" element={<TestSearch />} />
          <Route path="/global-screener" element={<GlobalScreenerPage />} />
          <Route path="/ema-strategy" element={<EmaStratDashboard />} />
          <Route
            path="/indexPage/:index_name"
            element={
              <PrivateRoute>
                <IndexDetail />
              </PrivateRoute>
            }
          />

          {/* Dummy pahe fpr testing */}
          <Route
            path="/stockdetailpage/:symbol/:securityId"
            element={<StockDetailPage />}
          />
          <Route path="/logs" element={<Logs />} />
          <Route path="/dropdown" element={<Dropdown />} />
        </Routes>
        {finalUser && (
          <>
            <ChatPanel2 />
            <AIFloatButton />
          </>
        )}
      </div>
      {finalUser && <Footer />}
      <ToastContainer
        position="top-right"
        autoClose={2000}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
        theme="colored"
        toastStyle={{
          marginTop: "75px",
        }}
      />
    </div>
  );
}

export default App;
